import type { Site } from '@hotjar/site';
import type { UseQueryResult } from 'react-query';
import { useQueries } from 'react-query';
import { getDailySessions } from '@hotjar/site';

export const DAILY_SESSION_QUERY_KEY = 'daily-session-query';

export const useDailySessions = (sites: Site[] | undefined): UseQueryResult[] => {
  return useQueries(
    (sites || []).map((site) => {
      return {
        queryKey: `${DAILY_SESSION_QUERY_KEY}-${site.id}`,
        queryFn: () => getDailySessions(site?.id ?? 0),
        enabled: site != null,
        staleTime: 60 * 60 * 1000, // 1 hour
        cacheTime: 60 * 60 * 1000, // 1 hour
        refetchOnWindowFocus: false,
      };
    }),
  );
};
